import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=d851ccc6&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=d851ccc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d851ccc6",
  null
  
)

export default component.exports